<template>
    <div class="content">
        <div>            
            <md-table v-model="contacts" table-header-color="blue">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
                <md-table-cell md-label="name">{{ item.name }}</md-table-cell>
                <md-table-cell md-label="message">{{ item.message }}</md-table-cell>
            </md-table-row>
            </md-table>
        </div>
    </div>
</template>
<script>
import {API} from '../services'

export default {
  name: "contacts",
  data() {
    return {
      contacts: []
    };
  },
  created: function () {
      API.getContacts().then(
                  response => {
                      console.log('RESPONSE')
                      console.log(response.data)
                    this.contacts = response.data
                  },
              );
  }

};
</script>
